'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bootstrapSwitch;
/**
 * Binding della libreria bootstrap-switch
 *
 * @example
 * <input type="checkbox" ng-model="mymodel.mystate" bootstrap-switch />
 *
 * @see https://github.com/nostalgiaz/bootstrap-switch
 */
function bootstrapSwitch() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {

      element.bootstrapSwitch({});

      element.on('switchChange.bootstrapSwitch', function (event, state) {
        if (ngModel) {
          scope.$apply(function () {
            ngModel.$setViewValue(state);
          });
        }
      });

      scope.$watch(attrs.ngModel, function (newValue) {
        element.bootstrapSwitch('state', !!newValue, true);
      });

      scope.$on('$destroy', function () {
        element.bootstrapSwitch('destroy');
      });
    }
  };
}
;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/bootstrapSwitch.directive.js
// module id = 140
// module chunks = 2